import { api } from '../service/api.service'

const EVENT_ENDPOINT = `/address`

function find (q) {
  return api.get(EVENT_ENDPOINT, { params: { q, limit: 25 } })
    .then(res => res.data)
}

export { find }
